import { CREDENTIALS_ROUTE } from "../constants";

export const isCredentialsRoute = (path) => {
  return CREDENTIALS_ROUTE.includes(path);
};
